import React from "react";

import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import MUIIcon from "../ui/MUIIcon";

import useLocalization from "../../hooks/useLocalization";

const MenuItem = ({ name, iconName, onClick }) => {
  const { getLabel } = useLocalization();

  return (
    <ListItem
      key={name}
      disablePadding
    >
      <ListItemButton onClick={onClick}>
        <ListItemIcon>
          <MUIIcon name={iconName} />
        </ListItemIcon>
        <ListItemText primary={getLabel(name)} />
      </ListItemButton>
    </ListItem>
  );
};

export default MenuItem;
